import { COLOR } from 'app-v2/design-tokens'
import React from 'react'
import type { Icon } from 'shared/utils'

export const Lock = (props: Icon) => {
    const {
        color = COLOR.PRIMARY,
        size = 24,
        className = 'lock',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            {...otherProps}>
            <path
                d="M17.437 8.4V6c0-3.314-2.658-6-5.937-6-3.28 0-5.938 2.686-5.938 6v2.4C3.595 8.4 2 10.012 2 12v8.4C2 22.388 3.595 24 5.562 24h11.875C19.405 24 21 22.388 21 20.4V12c0-1.988-1.595-3.6-3.563-3.6zM8 5.6C8 3.612 9.567 2 11.5 2S15 3.612 15 5.6V8H8V5.6z"
                fill={color}
                fillRule="evenodd"
            />
        </svg>
    )
}
